<div class="xvi-label" *ngIf="text$ | async">
  <xux-tooltip-icon
    *ngIf="iconConfig"
    [config]="iconConfig"
  ></xux-tooltip-icon>
  <label class="label-widget" [ngClass]="itemClass">
      <div class="label-widget__content" [innerHTML]="html$ | async | translate" ></div>
      <div class="label-widget__content clickable-text" [innerHTML]="otherTips | translate" (click)="onClickLabel($event)"></div>
  </label>
</div>


